import React from 'react';
import './Webinar-page.scss';
import Video from '../../components/video/Video';
import webinarVideo from '../../assets/video/Vicki-x-Planet-Fitness_2026-05-12.mp4';

function WebinarPage() {
    return (
        <div className={'webinar-page-wrapper'}>
            <h2 className={'webinar-title'}>Webinar</h2>
            <p className={'webinar-date'}>December 9</p>
            <div className={'webinar-video-container'}>
                <Video src={webinarVideo} />
            </div>
        </div>
    );
}

export default WebinarPage;
